<template>
  <section>
    <base-card>
      <h2>Page not found</h2>
      <p>
        This page could not be found - maybe check out all our
        <RouterLink to="/coaches">coaches</RouterLink>
      </p>
    </base-card>
  </section>
</template>

<script setup></script>

<style lang="scss" scoped></style>
